import React from 'react'
import { Route, Routes } from 'react-router'
import CompanyDashboardPage from '../app/admin/erp/finance/company/pages/ComapnyDashboardPage'
import LedgerGroupGroupListPage from '../app/admin/erp/finance/ledger/pages/LedgerGroupListPage'
import LedgerListPage from '../app/admin/erp/finance/ledger/pages/LedgerListPage'
import LedgerEntryPage from '../app/admin/erp/finance/ledger/pages/LedgerEntryPage'
import ProductDashboardPage from '../app/admin/erp/finance/product/pages/ProductDashboardPage'
import InventoryStockListPage from '../app/admin/erp/finance/inventory/pages/InventoryStockListPage'
import InventoryTransactionsPage from '../app/admin/erp/finance/inventory/pages/InventoryTransactionsPage'
import PartyListPage from '../app/admin/erp/finance/party/pages/PartyListPage'
import PartyDetailsPage from '../app/admin/erp/finance/party/pages/PartyDetailsPage'
import VoucherDashboardPage from '../app/admin/erp/finance/voucher/pages/VoucherDashboardPage'
import SalePurchaseVoucherDetailsPage from '../app/admin/erp/finance/voucher/pages/SalePurchaseVoucherDetailsPage'
import PaymentReceiptVoucherDetailsPage from '../app/admin/erp/finance/voucher/pages/PaymentReceiptVoucherDetailsPage'
import ContraJournalVoucherDetailsPage from '../app/admin/erp/finance/voucher/pages/ContraJournalVoucherDetailsPage'
import CreditDebitNoteVoucherDetailsPage from '../app/admin/erp/finance/voucher/pages/CreditDebitNoteVoucherDetailsPage'
import FinanceDashboardPage from '../app/admin/erp/finance/reports/pages/FinanceDashboardPage'
import CompanyLocationListPage from '../app/admin/erp/finance/company/pages/CompanyLocationListPage'
import ExpenseVoucherDetailsPage from '../app/admin/erp/finance/voucher/pages/ExpenseVoucherDetailsPage'
import CompanyVoucherSettingPage from '../app/admin/erp/finance/company/pages/CompanyVoucherSettingPage'
import ChallanVoucherDetailsPage from '../app/admin/erp/finance/voucher/pages/ChallanVoucherDetailsPage'

import LedgerDetailsPage from '../app/admin/erp/finance/ledger/pages/LedgerDetailsPage'
import { useAuth } from '../context/AuthContext'
import FinanceReportRoutes from './FinanceReportRoutes'
import TermsTemplateListPage from '../app/admin/erp/finance/termsTemplate/pages/TermsTemplateList'
import InventoryTransferDetailsPage from '../app/admin/erp/finance/inventory/pages/InventoryTransferDetailsPage'
import InventoryTransferVoucherListPage from '../app/admin/erp/finance/inventory/pages/InventoryTransferVoucherListPage'

import LedgerImportPage from '../app/admin/erp/finance/dataImport/pages/LedgerImportPage'
import StockImportPage from '../app/admin/erp/finance/dataImport/pages/StockImportPage'
import VoucherImportPage from '../app/admin/erp/finance/dataImport/pages/VoucherImportPage'
import DatabaseUpdateScriptsPage from '../app/admin/erp/finance/dataImport/pages/DatabaseUpdateScriptsPage'






function FinanceRoutes() {
  const {authUser} = useAuth();
  return (
    <>
      <Routes>
        
        {authUser.role == 3  && <Route path="/" element={<FinanceDashboardPage /> }></Route> }
        <Route path="/finance/dashboard" element={<FinanceDashboardPage /> }></Route>
        <Route path="/company/dashboard" element={<CompanyDashboardPage /> }></Route>
        <Route path="/company-location/list" element={<CompanyLocationListPage /> }></Route>
        <Route path="/voucher-setting" element={<CompanyVoucherSettingPage /> }></Route>

        <Route path="/ledger-group/list" element={<LedgerGroupGroupListPage /> }></Route>
        <Route path="/ledger/list" element={<LedgerListPage /> }></Route>
        <Route path="/ledger-details/:ledgerId" element={<LedgerDetailsPage /> }></Route>
        <Route path="/ledger-entry/list" element={<LedgerEntryPage /> }></Route>
        

        <Route path="/product/dashboard" element={<ProductDashboardPage /> }></Route>  
    
        <Route path="/inventory/stock-list" element={<InventoryStockListPage/> }></Route>
        <Route path="/inventory/transactions" element={<InventoryTransactionsPage/> }></Route>
        <Route path="/inventory/transfer/details/:id" element={<InventoryTransferDetailsPage/> }></Route>
        <Route path="/inventory/transfer-list" element={<InventoryTransferVoucherListPage/> }></Route>



      
        <Route path="/party/dashboard" element={<PartyListPage /> }></Route>
        <Route path="/party/details/:id" element={<PartyDetailsPage /> }></Route>

        <Route path="/voucher/dashboard" element={<VoucherDashboardPage /> }></Route>
        <Route path="/voucher/sale-purchase/details/:id" element={<SalePurchaseVoucherDetailsPage /> }></Route>
        <Route path="/voucher/payment-receipt/details/:id" element={<PaymentReceiptVoucherDetailsPage /> }></Route>
        <Route path="/voucher/contra-journal/details/:id" element={<ContraJournalVoucherDetailsPage /> }></Route>
        <Route path="/voucher/cd-note/details/:id" element={<CreditDebitNoteVoucherDetailsPage /> }></Route>
        <Route path="/voucher/expense/details/:id" element={<ExpenseVoucherDetailsPage /> }></Route>
        <Route path="/voucher/challan/details/:id" element={<ChallanVoucherDetailsPage /> }></Route>


        <Route path="/terms-template" element={<TermsTemplateListPage /> }></Route>

        <Route path="/import/stock" element={<StockImportPage /> }></Route>
        <Route path="/import/ledger" element={ <LedgerImportPage/> }></Route>
        <Route path="/import/voucher" element={ <VoucherImportPage/> }></Route>
        <Route path="/database/update" element={ <DatabaseUpdateScriptsPage/> }></Route>
        
      </Routes>
      <FinanceReportRoutes />
    </>
  )
}

export default FinanceRoutes